'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'prev',
    shape: _react2.default.createElement('path', { d: 'M256 448V320L0 512l256 192V576h128V448H256z' }),
    viewbox: '-39 275 470 470',
    label: 'Prev'
};
//# sourceMappingURL=prev.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-svg/lib/cjs/icons/prev.js
 ** module id = 354
 ** module chunks = 0
 **/